/*

  ・使用方法
  以下をhtmlに追加する。
  ※''で囲まれた部分は書き換えが必要またこの時''も一緒に削除する.
    
  -------------------------------------------------------------------------------
  
  <script> const '好きな名前ローマ字で' = new Pagination("#allul", 6, 3); </script>
  
  -------------------------------------------------------------------------------
  
  引数1 使用したいulのid
  引数2 ulに含まれるコンテンツの数 
  引数3 各ページを何コンテンツごとに区切るか

  ・ul作成仕様
  各liにクラス.hiddenを追加するまたhiddenがcssにない場合は以下をhtmlに追加する。
  -------------------------------------------------------------------------------
  
  <style>
  .hidden {
    display: none;
  }
  </style>
  
  -------------------------------------------------------------------------------
  
*/

class Pagination {
    constructor(containerSelector, countSelector, maxItemsPerPage) {
        this.container = document.querySelector(containerSelector);
        if (isNaN(countSelector)) {
            this.count = document.querySelector(countSelector).innerHTML;
        } else {
            this.count = countSelector;
        }
      
        this.maxItemsPerPage = maxItemsPerPage;
        this.currentPage = 0;

        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    init() {
        this.updateDisplay();
        this.createInputButtons();
    }

    
    createInputButtons() {
        const totalItems = this.count;
        const nnn = document.querySelector(".nnn");
        let remainingItems = totalItems;

        while (remainingItems > 0) {
            if (totalItems > this.maxItemsPerPage) {
                const div = document.createElement('div');
                div.classList.add("box_bk_01", "w_30px", "h_30px", "br30px");

                const input = document.createElement('input');
                const pageNumber = Math.ceil((totalItems - remainingItems) / this.maxItemsPerPage);

                input.type = "button";
                input.value = pageNumber + 1;
                input.dataset.positionval = pageNumber;

                input.addEventListener('click', (event) => {
                    this.goToPage(parseInt(input.dataset.positionval, 10));
                });

                div.appendChild(input);
                nnn.appendChild(div);
            }
            remainingItems -= this.maxItemsPerPage;
        }
    }

    /* ボタンを押したときの関数
    - 表示したいページをcurrentPageにいれる
    - updateDisplayを行う
    */
    goToPage(pageNumber) {
        this.currentPage = pageNumber;
        this.updateDisplay();
    }

    // 指定したページに対応するコンテンツの非表示、再表示を行う
    updateDisplay() {
        this.addHidden();
        this.removeHidden();
    }

    // 非表示にする
    addHidden() {
        const start = this.currentPage * this.maxItemsPerPage;
        const end = start + this.maxItemsPerPage;

        for(let i = 0; i < this.container.children.length; i++) {
            const child = this.container.children[i];
            if (i < start || i >= end) {
                child.classList.add("hidden");
            }
        }
    }

    // 再表示する
    removeHidden() {
        const start = this.currentPage * this.maxItemsPerPage;
        const end = Math.min(start + this.maxItemsPerPage, this.container.children.length);
    
        for (let i = start; i < end; i++) {
            const child = this.container.children[i];
            child.classList.remove("hidden");
        }
    }
}

